<template>
    <kiosk-team-details :teamId="props.teamId">
        <div class="col-span-12 lg:col-span-10 flex flex-col w-full justify-center">
            <groups-list :teamId="props.teamId" :overview="false" readOnly />
        </div>
    </kiosk-team-details>
</template>

<script lang="ts" setup>
import KioskTeamDetails from '../details/KioskTeamDetails.vue';
import GroupsList from '~/components/settings/teams/groups/list/GroupsList.vue';

const props = defineProps({
    teamId: {
        type: Number,
        required: true,
    },
});
</script>
